export const LogoFull = (props) => {
  const { width = 149, height = 33, onClick, verticalAlign, marginLeft, marginRight, top, color, className = '' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{ verticalAlign }} width={width} height={height}
        fill="none"
        viewBox="0 0 149 32"
      >
       <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.651 17.292a1.903 1.903 0 0 1 0-2.668L14.83 1.282a1.85 1.85 0 0 1 2.636 0l13.179 13.342a1.903 1.903 0 0 1 0 2.668l-13.18 13.342a1.85 1.85 0 0 1-2.635 0zM15.71 4.543a.616.616 0 0 1 .878 0l4.393 4.448a.636.636 0 0 1 0 .89L10.145 20.85a.616.616 0 0 1-.88 0l-4.392-4.448a.635.635 0 0 1 0-.89zm6.443 6.523a.616.616 0 0 1 .878 0l4.393 4.448a.635.635 0 0 1 0 .89L23.03 20.85a.616.616 0 0 1-.878 0l-4.393-4.447a.634.634 0 0 1 0-.89z"
      clipRule="evenodd"
    ></path>
    <path fill="currentColor" d="M77.304 24.227V7.572H73.88v16.655z"></path>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M54.115 20.621c-.27.255-.87.45-1.625.45-.987 0-1.78-.587-2.13-1.527h7.742c.059-.373.078-.804.078-1.216 0-3.428-2.458-6.014-5.729-6.014s-5.748 2.586-5.748 5.995c0 3.527 2.4 6.015 5.806 6.015 2.38 0 4.451-1.508 5.245-3.703zm-3.754-3.566c.348-.9 1.103-1.47 2.09-1.47s1.723.549 2.07 1.47z"
      clipRule="evenodd"
    ></path>
    <path
      fill="currentColor"
      d="M45.779 12.333c-1.626 0-2.903.745-3.658 1.626V12.47h-3.445v11.756h3.445V18.74c0-1.94 1.258-2.92 3.658-2.939z"
    ></path>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M71.804 24.226h-3.445V23.13c-.426.666-1.742 1.215-3 1.215-3.425 0-5.535-2.39-5.535-6.016 0-3.604 2.11-5.995 5.535-5.995 1.258 0 2.555.53 3 1.235V12.47h3.445zm-5.98-8.425c-1.568 0-2.555 1-2.555 2.527 0 1.549.987 2.528 2.555 2.528 1.51 0 2.554-1.038 2.535-2.508 0-1.45-1.064-2.547-2.535-2.547M82.847 24.227h-3.425V7.572h3.425v5.996c.446-.705 1.742-1.235 3.02-1.235 3.425 0 5.515 2.391 5.515 5.996 0 3.625-2.09 6.015-5.515 6.015-1.258 0-2.594-.548-3.02-1.215zm2.555-3.37c1.567 0 2.555-.98 2.555-2.528 0-1.528-.988-2.527-2.555-2.527-1.51 0-2.574 1.116-2.555 2.625.02 1.43 1.065 2.43 2.555 2.43"
      clipRule="evenodd"
    ></path>
    <path
      fill="currentColor"
      d="M100.161 12.333c-1.626 0-2.903.745-3.657 1.626V12.47h-3.445v11.756h3.445V18.74c0-1.94 1.258-2.92 3.657-2.939zM101.797 12.47h3.445v11.756h-3.445zM112.604 15.782c.891 0 1.549.43 1.955 1.058h3.639c-.522-2.744-2.613-4.526-5.594-4.526-3.425 0-5.69 2.39-5.69 5.995 0 3.625 2.265 6.015 5.69 6.015 2.981 0 5.072-1.783 5.594-4.546h-3.639c-.388.667-1.064 1.059-1.955 1.059-1.354 0-2.245-1-2.245-2.528 0-1.509.891-2.527 2.245-2.527M123.371 19.093v5.134h-3.426V7.572h3.426v10.071l3.619-5.173h3.735l-3.619 5.879 4.026 5.878h-4.355zM131.426 20.092c-.019 2.782 2.362 4.252 4.549 4.252 2.593 0 4.548-1.568 4.548-3.625 0-2.802-2.129-3.41-3.793-3.82-1.007-.236-1.568-.393-1.568-.902 0-.49.368-.744.87-.744.658 0 1.181.548 1.142 1.195h3.058c.039-2.43-1.683-4.115-4.18-4.115-2.439 0-4.316 1.313-4.316 3.723 0 2.444 1.777 2.979 3.232 3.417h.001q.25.075.483.149l.239.085c.726.255 1.387.488 1.387 1.071 0 .412-.348.627-1.007.646-.774 0-1.413-.607-1.393-1.332zM101.797 7.572h3.445v3.605h-3.445zM142.079 8.107c.505 0 .836-.277.836-.79 0-.511-.331-.757-.849-.757h-.805v1.547zm-1.536-2.21h1.569c.935 0 1.534.505 1.534 1.409 0 .682-.375 1.112-.904 1.301l1.023 1.713h-.836l-.924-1.561c-.007-.006-.232 0-.238 0h-.506v1.56h-.718z"
    ></path>
    <mask
      id="mask0_1160_7129"
      width="10"
      height="10"
      x="137"
      y="3"
      maskUnits="userSpaceOnUse"
      style={{ maskType: "luminance" }}
    >
      <path fill="#fff" d="M137.613 3.64h8.82v8.931h-8.82z"></path>
    </mask>
    <g mask="url(#mask0_1160_7129)">
      <path
        fill="currentColor"
        d="M142.022 4.407c-.492 0-.972.098-1.421.29a3.706 3.706 0 0 0-2.23 3.409 3.706 3.706 0 0 0 2.23 3.407c.449.193.929.29 1.421.29.494 0 .971-.097 1.422-.29a3.686 3.686 0 0 0 1.945-1.969c.191-.454.287-.94.287-1.438a3.7 3.7 0 0 0-2.232-3.409 3.6 3.6 0 0 0-1.422-.29m0 8.163a4.3 4.3 0 0 1-1.715-.351 4.443 4.443 0 0 1-2.347-2.375 4.5 4.5 0 0 1-.347-1.738 4.49 4.49 0 0 1 1.292-3.158 4.4 4.4 0 0 1 1.402-.956 4.3 4.3 0 0 1 1.715-.351c.597 0 1.173.118 1.718.35.525.225.995.547 1.402.957.405.41.723.887.943 1.42.232.55.348 1.135.348 1.738a4.45 4.45 0 0 1-.348 1.737 4.42 4.42 0 0 1-2.345 2.375 4.3 4.3 0 0 1-1.718.352"
      ></path>
    </g>
  </svg>
    </span>
  );
};
